module.exports = __webpack_public_path__ + "sprites-128.5e6107802e33b650f16c.svg";


//////////////////
// WEBPACK FOOTER
// ./~/@c4/assets/src/assets/images/sprites/sprites-128.svg
// module id = 33
// module chunks = 2